import './heading.scss';

const OnboardHeading = ({ children }) => {
    return <h1 className={'onboard-heading'}>{children}</h1>
}

export default OnboardHeading;